import React from 'react';
import image from '../../image/240_F_211095871_r74aavHAmiLk8xeCuL3SBfnOivgsj0ZQ.jpg';

const HeaderBaner = () => {
    return (
        <div className=' md:flex ml-3 mt-5'>
           <div className='min-w-[50%]'>
           <img className='h-48  min-w-[100%]' src={image} alt="" />
           </div>
         <div className='px-20 pt-10 text-center text align-middle bg-teal-100'>
         <p className=''>This Website Design & Develop For Assignment.  
         Some Data is Loded From The API And Show on the Card 
         And Some Questions & Answer are Show on a Separate path</p>
         </div>
        </div>
    );
};

export default HeaderBaner;